import { Loader } from '@mantine/core';
import { PlusCircleSVG, RefreshSVG } from 'common/assets';
import { AuthorizationRules, NavigationRoutes } from 'common/constants';
import ParsePassport, {
  PassportType,
} from 'components/common/parse-excel/parse-passport';
import Separator from 'components/common/separator';
import { Button } from 'components/elements/buttons';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer from 'hooks/use-drawer';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import MassUpdatePassportPanel from './panel/mass-update-passport-panel';

interface Props {
  query: any;
  onCreate?: () => void;
  onRefresh?: () => void;
  showAdd?: boolean;
  linkAdd?: NavigationRoutes;
}

export default function ListHeaderActionComponent(props: Props) {
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const drawer = useDrawer();
  const { query, onCreate, onRefresh, showAdd, linkAdd } = props;
  const onParsePassport = (result: PassportType[]) => {
    drawer.showCustom({
      backdropClose: true,
      render: (onClose) => (
        <MassUpdatePassportPanel result={result} onClose={onClose} />
      ),
    });
  };

  const addComponent = (
    <Button
      onClick={
        typeof linkAdd === 'string'
          ? undefined
          : () => {
              onCreate?.();
            }
      }
      startEnhancer={(color, size) => (
        <PlusCircleSVG size={size} color={color} />
      )}
      style={styles.button}
    >
      {t('common:add')}
    </Button>
  );
  return (
    <>
      {can(AuthorizationRules.GuestsMassUpdatePassports) && (
        <>
          <ParsePassport onResult={onParsePassport} />
          <Separator gap={16} />
        </>
      )}
      <Button
        onClick={() => {
          onRefresh?.();
        }}
        startEnhancer={(color, size) => {
          if (query.isFetching) {
            return <Loader color={color} size={size} />;
          }
          return <RefreshSVG color={color} size={size} />;
        }}
        buttonType="secondary"
        style={styles.button}
        disabled={query.isFetching}
      >
        {t('common:refresh')}
      </Button>
      {showAdd && (
        <>
          <Separator gap={16} />
          {linkAdd ? (
            <Link href={linkAdd} passHref>
              {addComponent}
            </Link>
          ) : (
            addComponent
          )}
        </>
      )}
    </>
  );
}

const styles = {
  button: {
    // padding: '12px ',
    minWidth: '120px !important',
    // padding: '6px 24px !important',
  },
};
